export default {
  manage_deleteVehicleStatus_deleteStatusLabel: "Delete Status Label",
  manage_deleteVehicleStatus_deleteStatusLabels: "Delete Status Labels",
  manage_deleteVehicleStatus_confirmationMessage:
    "Are you sure you want to delete the following Status Labels?"
};
